import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CmsService } from '@spartacus/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-general-conditions',
  templateUrl: './general-conditions.component.html',
  styleUrls: ['./general-conditions.component.scss'],
  standalone: false
})
export class GeneralConditionsComponent {

  webshopContent: any;
  subscription = new Subscription();
  constructor(private dialogRef: MatDialogRef<GeneralConditionsComponent>, private cmsService: CmsService) {

  }

  accept() {
    this.dialogRef.close(true);
  }
  ngOnInit() {
    this.subscription.add(this.cmsService.getComponentData('termOfUseNA').subscribe((data: any) => {
      if (data) {


        this.webshopContent = data.content;
      }
    }))
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
